import { withDirectModifiedFields } from 'utils/pendingChanges';

export class LoanPropertyApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getProperties({ applicationId, withSubjectProperty = false }) {
    return this.#http.get(`/api/applications/${applicationId}/properties`, {
      params: {
        withSubjectProperty,
      },
    });
  }

  async getSubjectPropertySummaryView({ applicationId }) {
    return withDirectModifiedFields(
      await this.#http.get(`/api/applications/${applicationId}/subject-property/summary/view`),
    );
  }

  async getSubjectPropertyEditData({ applicationId }) {
    return this.#http.get(`/api/applications/${applicationId}/subject-property/summary`);
  }
}
